export const ROUTE_METADATA_KEYS = ['url', 'path', 'title', 'generateUrl', 'Types'] as const;

export type RouteMetadataKeys = (typeof ROUTE_METADATA_KEYS)[number];
